import { Building2, Calendar, Rocket, ShieldCheck } from "lucide-react";

const ABOUT_IMG = "/brand/technopark.jpg";

export default function About() {
  return (
    <section id="about" className="section-pad bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative reveal">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_30px_80px_-30px_rgba(13,27,64,0.4)]">
              <img
                src={ABOUT_IMG}
                alt="Technopark Phase III buildings — Thiruvananthapuram, Kerala"
                className="w-full h-[460px] object-cover"
                loading="lazy"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(13,27,64,0) 50%, rgba(13,27,64,0.55) 100%)",
                }}
              />
            </div>
            <div className="hidden md:block absolute -bottom-7 -left-7 bg-[#F5A623] text-[#0D1B40] px-7 py-5 rounded-xl shadow-xl">
              <div className="text-[28px] font-extrabold leading-none">2016</div>
              <div className="text-[12px] font-semibold tracking-[0.2em] mt-2">FOUNDED</div>
            </div>
            <div className="hidden md:flex absolute -top-6 -right-6 bg-[#0D1B40] text-white px-6 py-4 rounded-xl shadow-xl items-center gap-3">
              <ShieldCheck className="text-[#F5A623]" size={22} />
              <div className="text-[13px] font-semibold leading-tight">
                Backed by<br />
                <span className="text-[#F5A623]">Kerala Startup Mission</span>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="reveal">
            <div className="eyebrow mb-4">About Rydey</div>
            <h2 className="headline text-[34px] md:text-[44px] mb-5" data-testid="about-headline">
              Transforming employee commute, one ride at a time.
            </h2>
            <p className="text-[16px] md:text-[17px] leading-relaxed text-slate-600 mb-6">
              Rydey was established with the mission of transforming employee commute
              experiences. We provide end-to-end cab and fleet management services tailored
              to modern corporate clients across Technopark and major technology parks in
              Kerala.
            </p>
            <p className="text-[16px] leading-relaxed text-slate-600 mb-8">
              Operating on an aggregator model, we guarantee <strong className="text-[#0D1B40]">100% reliability</strong> — never letting
              a shift, a meeting, or a flight go uncovered. Started under the
              <strong className="text-[#0D1B40]"> Kerala Startup Mission</strong> initiative.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              <Pill icon={<Building2 size={18} />} title="Operating Company" value="Lagnitta Technologies Pvt Ltd" />
              <Pill icon={<Rocket size={18} />} title="Brand" value="RYDEY" />
              <Pill icon={<Calendar size={18} />} title="Established" value="2016" />
              <Pill icon={<ShieldCheck size={18} />} title="Headquarters" value="Thiruvananthapuram, Kerala" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Pill({ icon, title, value }) {
  return (
    <div className="flex items-start gap-3 p-4 rounded-xl border border-slate-200 bg-white card-elevate">
      <div className="w-9 h-9 rounded-md bg-[#0D1B40] text-[#F5A623] flex items-center justify-center shrink-0">
        {icon}
      </div>
      <div>
        <div className="text-[11px] font-semibold tracking-[0.16em] text-slate-500 uppercase">{title}</div>
        <div className="text-[#0D1B40] font-semibold text-[14px] mt-0.5">{value}</div>
      </div>
    </div>
  );
}
